<script type="text/javascript">
    import { http } from '../../http';
    import $ from 'jquery';

    export default {
        props: {
            signupPageUrl: {
                required: false,
                default: trans('global.website_signup_url'),
            },
            logoUrl: {
                required: false,
                default: null,
            },
            message: {
                required: false,
                default: '',
            },
            practizeShell: {
                required: false,
                type: Boolean,
                default: false,
            },
        },

        data: () => {
            return {
                loginEmail: '',
                loading: false,
                password: '',
                recoverEmail: '',
                submitLoading : false,
                submitRecoverLoading : false,
                showError: false,
                errorMessage: null,
                showRecoverPassword: false,
                showRecoverPasswordSuccess: false,
                showRecoverPasswordError: false,
            }
        },

        mounted() {
            this.bindInputListeners();

            this.$root.$on('countryUpdated', country => {
                this.$forceUpdate();
            });
        },

        updated() {
            this.bindInputListeners();
        },

        methods: {
            bindInputListeners() {
                $('input').off('focus');
                $('input').off('blur');

                $('input').on('focus', function () {
                    $('p.create-cta').addClass('hidden-xs');
                });

                $('input').on('blur', function () {
                    $('p.create-cta').removeClass('hidden-xs');
                });
            },

            hideMessages() {
                this.showError = false;
                this.showRecoverPasswordSuccess = false;
            },

            hideRecoverPasswordForm() {
                this.showRecoverPassword = false;
                this.showRecoverPasswordError = false;
            },

            showRecoverPasswordForm() {
                this.showRecoverPassword = true;
                this.showRecoverPasswordError = false;
            },

            submitLoginForm() {
                this.hideMessages();

                var data = {
                    email: this.loginEmail,
                    p: this.password,
                }

                this.submitLoading = true;
                http.post("/", data)
                    .then(() => {
                        window.location.href = '/';
                    })
                    .catch((error) => {
                        this.errorMessage = error.response.data.message;
                        this.showError = Boolean(this.errorMessage);
                        this.submitLoading = false;
                    });
            },

            submitRecoverPasswordForm() {
                this.hideMessages();
                this.showError = false;

                var data = {
                    email: this.recoverEmail,
                }

                this.submitRecoverLoading = true;

                this.showRecoverPasswordError = false;

                http.post('/recover', data)
                    .then(() => {
                        this.showRecoverPasswordSuccess = true;
                        this.showRecoverPassword = false;
                        this.submitRecoverLoading = false;
                    }).catch((error, data) => {
                        this.submitRecoverLoading = false;
                        if(error.response.data.email){
                            this.showRecoverPasswordError = error.response.data.email[0];
                        }
                    });
            }
        }
    }
</script>

<template id="login-form">
    <div>
        <div class="preloader" id="preloader" v-if="loading"></div>

        <template v-if="practizeShell">
            <div class="practize-login-form" v-if="!showRecoverPassword && !loading">
                <div class="message-container">
                    <div class="message error-message" v-if="showError">
                        <p>
                            <svg version="1.1" id="errorIcon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 47 47" aria-hidden="true">
                                <g>
                                    <path d="M22.8,46c-12.6-0.2-22.1-10.1-22-22.8C1,10.6,11.4,0.4,24,0.7C36.6,1,46.3,11.3,46.2,24.1C46,36.8,36,46.2,22.8,46z
                                         M23.5,40.8c10.1,0,17.4-7.2,17.4-17.2c0-10-7.4-17.6-17.2-17.7C13.7,5.8,6,13.5,6.1,23.6C6.2,33.7,13.4,40.8,23.5,40.8z"/>
                                </g>
                                <line class="st0" x1="23" y1="11" x2="23" y2="26"/>
                                <circle cx="23" cy="33" r="3"/>
                            </svg>
                            {{ trans(`login.${errorMessage}`) }}
                        </p>
                    </div>

                    <template v-if="showRecoverPasswordSuccess">
                        <div class="message mail-sent-message">
                            <p>{{ trans('login.new_password_confirmation') }}</p>
                        </div>

                        <a href="" class="forgot-password-link" @click.prevent="showRecoverPasswordSuccess = false;">&#8592; {{ trans('global.back') }}</a>
                    </template>

                    <template v-if="message != ''">
                        <div class="message mail-sent-message">
                            <p>{{ message }}</p>
                        </div>
                    </template>
                </div>

                <form id="login" action="" method="post" class="mainForm" @submit.prevent="submitLoginForm()" v-if="!showRecoverPasswordSuccess" :aria-label="trans('login.log_in')">
                    <h1 class="form-title">{{ trans('login.log_in') }}</h1>

                    <div class="field">
                        <label for="username">{{ trans('login.form_label_email') }}</label>
                        <input type="email" id="username" name="email" autocomplete="email" placeholder="name@example.com" v-model="loginEmail" required>
                    </div>

                    <div class="field">
                        <label for="password">{{ trans('login.form_label_password') }}</label>
                        <input type="password" id="password" name="password" autocomplete="current-password" v-model="password" required>
                    </div>

                    <div class="form-actions">
                        <a href="#" id="forgotPasswordLink" class="forgot-password-link" @click.prevent="showRecoverPasswordForm">{{ trans('login.forgot_password_short') }}</a>
                    </div>

                    <button class="primary-btn" id="submitLogin" :disabled="submitLoading">
                        <span v-if="!submitLoading">{{ trans('login.log_in') }}</span>

                        <svg v-else version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                             width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve" aria-hidden="true">
                            <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                                <animateTransform attributeType="xml"
                                                  attributeName="transform"
                                                  type="rotate"
                                                  from="0 25 25"
                                                  to="360 25 25"
                                                  dur="0.6s"
                                                  repeatCount="indefinite"/>
                            </path>
                        </svg>
                    </button>

                    <div class="security-note">
                        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                            <path d="M8 1.5L13 3.5V7.5C13 10.6 11 13.1 8 14.5C5 13.1 3 10.6 3 7.5V3.5L8 1.5Z" stroke="currentColor" stroke-width="1.5"/>
                            <path d="M6 8L7.5 9.5L10.5 6.5" stroke="currentColor" stroke-width="1.5"/>
                        </svg>
                        <p>{{ trans('login.security_note') }}</p>
                    </div>
                </form>
            </div>

            <div class="practize-login-form" id="forgotPasswordWrapper" v-else-if="showRecoverPassword && !loading">
                <div class="message-container">
                    <div class="message error-message" v-if="showRecoverPasswordError">
                        <p>
                            <svg version="1.1" id="errorIcon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 47 47" aria-hidden="true">
                                <g>
                                    <path d="M22.8,46c-12.6-0.2-22.1-10.1-22-22.8C1,10.6,11.4,0.4,24,0.7C36.6,1,46.3,11.3,46.2,24.1C46,36.8,36,46.2,22.8,46z
                                         M23.5,40.8c10.1,0,17.4-7.2,17.4-17.2c0-10-7.4-17.6-17.2-17.7C13.7,5.8,6,13.5,6.1,23.6C6.2,33.7,13.4,40.8,23.5,40.8z"/>
                                </g>
                                <line class="st0" x1="23" y1="11" x2="23" y2="26"/>
                                <circle cx="23" cy="33" r="3"/>
                            </svg>
                            {{ showRecoverPasswordError }}
                        </p>
                    </div>
                </div>

                <form action="" method="post" id="forgotPasswordForm" class="mainForm" @submit.prevent="submitRecoverPasswordForm()" ref="recover-password-form" :aria-label="trans('passwords.reset_password')">
                    <h1 class="form-title">{{ trans('login.form_label_forgot_password') }}</h1>
                    <p class="forgot-password-text">
                        {{ trans('login.forgot_password_instructions_1') }}
                        {{ trans('login.forgot_password_instructions_2') }}
                        <a :href="'mailto:' + trans('global.system_email')">{{ trans('global.system_email') }}</a>
                    </p>

                    <div class="field">
                        <label for="forgotPassword">{{ trans('login.form_label_email') }}</label>
                        <input type="email" name="email" id="forgotPassword" autocomplete="email" placeholder="name@example.com" v-model="recoverEmail" required>
                    </div>

                    <button class="primary-btn submitForm" id="sendPasswordButton" :disabled="submitRecoverLoading">
                        <span v-if="!submitRecoverLoading">{{ trans('passwords.reset_password') }}</span>

                        <svg v-else version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                             width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve" aria-hidden="true">
                            <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                                <animateTransform attributeType="xml"
                                                  attributeName="transform"
                                                  type="rotate"
                                                  from="0 25 25"
                                                  to="360 25 25"
                                                  dur="0.6s"
                                                  repeatCount="indefinite"/>
                            </path>
                        </svg>
                    </button>

                    <a href="#" id="backToLogin" class="back-to-login" @click.prevent="hideRecoverPasswordForm()">{{ trans('login.forgot_password_back') }}</a>
                </form>
            </div>

        </template>

        <template v-else>
        <div v-if="logoUrl && String(logoUrl).trim() !== ''" class="custom-logo-container">
            <img :src="logoUrl" alt="">
        </div>
        <div class="logo-container" v-else></div>

        <div class="login-form-wrapper form-wrapper" id="loginFormWrapper" v-if="!showRecoverPassword && !loading">
            <div class="message-container">

                <div class="message error-message" v-if="showError">
                    <p>
                        <svg version="1.1" id="errorIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 47 47">
                            <g>
                                <path d="M22.8,46c-12.6-0.2-22.1-10.1-22-22.8C1,10.6,11.4,0.4,24,0.7C36.6,1,46.3,11.3,46.2,24.1C46,36.8,36,46.2,22.8,46z
                                     M23.5,40.8c10.1,0,17.4-7.2,17.4-17.2c0-10-7.4-17.6-17.2-17.7C13.7,5.8,6,13.5,6.1,23.6C6.2,33.7,13.4,40.8,23.5,40.8z"/>
                            </g>
                            <line class="st0" x1="23" y1="11" x2="23" y2="26"/>
                            <circle cx="23" cy="33" r="3"/>
                        </svg>
                        {{ trans(`login.${errorMessage}`) }}
                    </p>
                </div>

                <template v-if="showRecoverPasswordSuccess">
                  <div class="message mail-sent-message" >
                      <p>
                          {{ trans('login.new_password_confirmation') }}
                      </p>
                  </div>

                  <a href="" class="forgot-password-link" @click.prevent="showRecoverPasswordSuccess = false;">&#8592; {{ trans('global.back') }}</a>
                </template>

                <template v-if="message != ''">
                  <div class="message mail-sent-message" >
                      <p>
                          {{ message }}
                      </p>
                  </div>
                </template>

            </div>

            <form id="login" action="" method="post" class="mainForm" @submit.prevent="submitLoginForm()" v-if="!showRecoverPasswordSuccess">
                <div class="input-container">
                    <input type="email" id="username" name="email" :placeholder="trans('login.form_label_email')" v-model="loginEmail" required>
                    <input type="password" id="password" name="password" :placeholder="trans('login.form_label_password')" v-model="password" required>
                </div>

                <a href="#" id="forgotPasswordLink" class="forgot-password-link" @click.prevent="showRecoverPasswordForm">{{ trans('login.form_label_forgot_password') }}</a>

                <button id="submitLogin">

                    <span v-if="!submitLoading">{{ trans('online_booking.login') }}</span>
 
                    <svg v-else version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                    <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                        <animateTransform attributeType="xml"
                                          attributeName="transform"
                                          type="rotate"
                                          from="0 25 25"
                                          to="360 25 25"
                                          dur="0.6s"
                                          repeatCount="indefinite"/>
                    </path>
                    </svg>

                </button>

            </form>
        </div>

        <div class="forgot-password-wrapper form-wrapper" id="forgotPasswordWrapper" v-else-if="showRecoverPassword && !loading">

            <div class="message-container">

                <div class="message error-message" v-if="showRecoverPasswordError">
                    <p>
                        <svg version="1.1" id="errorIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 47 47">
                            <g>
                                <path d="M22.8,46c-12.6-0.2-22.1-10.1-22-22.8C1,10.6,11.4,0.4,24,0.7C36.6,1,46.3,11.3,46.2,24.1C46,36.8,36,46.2,22.8,46z
                                     M23.5,40.8c10.1,0,17.4-7.2,17.4-17.2c0-10-7.4-17.6-17.2-17.7C13.7,5.8,6,13.5,6.1,23.6C6.2,33.7,13.4,40.8,23.5,40.8z"/>
                            </g>
                            <line class="st0" x1="23" y1="11" x2="23" y2="26"/>
                            <circle cx="23" cy="33" r="3"/>
                        </svg>
                        {{ showRecoverPasswordError }}
                    </p>
                </div>
            </div>

            <div class="loginform" id="showForgotPassword">
                <form action="" method="post" id="forgotPasswordForm" @submit.prevent="submitRecoverPasswordForm()" ref="recover-password-form">
                    <p class="forgot-password-text">{{ trans('login.forgot_password_instructions_1') }}<br/><br/>
                    {{ trans('login.forgot_password_instructions_2') }} <a :href="'mailto:' + trans('global.system_email')">{{ trans('global.system_email') }}</a>
                    </p>

                    <div class="input-container">
                        <input type="email" name="email" id="forgotPassword" :placeholder="trans('login.form_label_email')" v-model="recoverEmail" required>
                    </div>

                    <button class="submitForm" id="sendPasswordButton">

                        <span v-if="!submitRecoverLoading">{{ trans('passwords.reset_password') }}</span>

                        <svg v-else version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                          <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                            <animateTransform attributeType="xml"
                              attributeName="transform"
                              type="rotate"
                              from="0 25 25"
                              to="360 25 25"
                              dur="0.6s"
                              repeatCount="indefinite"/>
                            </path>
                          </svg>

                    </button>

                    <a href="#" id="backToLogin" @click.prevent="hideRecoverPasswordForm()">{{ trans('login.forgot_password_back') }}</a>
                </form>
            </div>
        </div>

        <p class="create-cta">
            <a :href="signupPageUrl">
                <span v-html="trans('login.no_account')">{{ trans('login.no_account') }}</span>
                <u v-html="trans('login.sign_up')">{{ trans('login.sign_up') }}</u>
            </a>
        </p>
        </template>
    </div>
</template>
